module.exports = __webpack_public_path__ + "img/310.ce961073.png";